import React from 'react';
import propTypes from 'prop-types';
import { get } from 'lodash';
import { Dropdown } from '@tcc/crate';

const DropdownValidation = ({
  className,
  options,
  setValue,
  validationResult,
  value
}) => {

  const isInvalid = get(validationResult, 'isInvalid', false);
  const resultedFromUserInput = get(validationResult, 'resultedFromUserInput', false);
  const helpMessage = get(validationResult, 'helpMessages[0]', null);

  return (
    <Dropdown
      className={className}
      error={isInvalid && resultedFromUserInput && helpMessage}
      options={options}
      setValue={setValue}
      value={value}
    />
  );
};
DropdownValidation.propTypes = {
  className: propTypes.string,
  options: propTypes.array,
  setValue: propTypes.func,
  validationResult: propTypes.object,
  value: propTypes.string
};
export default DropdownValidation;
